import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import moment from 'moment';

import { SingleRedio, SingleText, SingleInput, SingleSelect } from '../../../Res/BaseInput';
import { CancelSubmitButton, Space, EditButton, SingleButton } from '../../../Res/BaseButton';
import { ContentBox } from '../../../Content/ContentBox';
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { getval2Token } from '../../../../Login/Auth';
import { api_addPlayer, api_getPlayerDetail, api_checkPlayerName } from '../../../../../api/MyStat/apiPlayer';
import { get_player_position_string, get_player_throw_bat_string, player_position_attr, player_throw_bat_attr, ReqPlayerDetail, RespPlayer, TITLE_player_activation, TITLE_player_DOB, TITLE_player_height, TITLE_player_id, TITLE_player_last_change, TITLE_player_name, TITLE_player_name_eng, TITLE_player_note, TITLE_player_pic_profile, TITLE_player_position, TITLE_player_throw_bat, TITLE_player_weight } from '../../../../../item/MyStat/ItemPlayer';
import { UploadPhoto } from '../UploadPhoto';
import { get_activation_string, activation_Items } from '../../../../../item/MyStat/ItemMyStatBase';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import { PlayerHistoryList } from './PlayerHistoryList';


export function PlayerEdit({ id, setIsLoading, isEdit, isAdd = false }) {
  const [tokenId, setTokenId] = useState("")

  const [_id, set_id] = useState("")
  const [player_id, set_player_id] = useState("")
  const [player_name, set_player_name] = useState("")
  const [player_name_eng, set_player_name_eng] = useState("")
  const [player_DOB, set_player_DOB] = useState("")
  const [player_activation, set_player_activation] = useState(1)
  const [player_last_change, set_player_last_change] = useState("")
  const [player_position, set_player_position] = useState("")
  const [player_throw_bat, set_player_throw_bat] = useState("")
  const [player_height, set_player_height] = useState("")
  const [player_weight, set_player_weight] = useState("")
  const [player_note, set_player_note] = useState("")

  const [player_pic_profile, set_player_pic_profile] = useState("")
  const [player_pic_profile_auth, set_player_pic_profile_auth] = useState(0)
  const [player_pic_profile_date, set_player_pic_profile_date] = useState("")

  const [player_pic_game, set_player_pic_game] = useState("")
  const [player_pic_game_auth, set_player_pic_game_auth] = useState(0)
  const [player_pic_game_date, set_player_pic_game_date] = useState("")

  const [isCheckRepeat, setCheckRepeat] = useState(false)
  const [isRepeat, setRepeat] = useState(false)
  const [repeatMessage, setRepeatMessage] = useState("")

  const [birthError, setBirthError] = useState(false)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("PlayerEdit", id)
      console.log(obj)
      set_player_id(obj.player_id)
      setTokenId(id)
    }
  }, [id])

  useEffect(() => {
    if (player_id !== undefined && player_id !== "") {
      // setIsLoading(true)
      var mReqPlayerDetail = new ReqPlayerDetail({
        player_id
      })
      getDetail(mReqPlayerDetail)
    }
  }, [player_id])

  function getDetail(mReqPlayerDetail) {
    console.log(mReqPlayerDetail)
    setIsLoading(true)
    api_getPlayerDetail({
      mReqPlayerDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespPlayer = new RespPlayer({})
        mRespPlayer.fromJson(jsonData.detail)

        set_id(mRespPlayer._id)
        set_player_name(mRespPlayer.player_name)
        set_player_name_eng(mRespPlayer.player_name_eng)
        set_player_DOB(moment(mRespPlayer.player_DOB).format('YYYY-MM-DD'))
        set_player_activation(mRespPlayer.player_activation)
        set_player_position(parseInt(mRespPlayer.player_position,10))
        set_player_throw_bat(parseInt(mRespPlayer.player_throw_bat,10))
        set_player_height(mRespPlayer.player_height)
        set_player_weight(mRespPlayer.player_weight)
        set_player_last_change(moment(mRespPlayer.player_last_change).format('YYYY-MM-DD'))
        set_player_note(mRespPlayer.player_note)
        set_player_pic_profile(mRespPlayer.player_pic_profile)
        set_player_pic_profile_auth(mRespPlayer.player_pic_profile_auth)

        var pic_profile_date = moment(mRespPlayer.player_pic_profile_date).format('YYYY-MM-DD HH:mm:ss')
        if (pic_profile_date === "Invalid date")
          pic_profile_date = ""
        set_player_pic_profile_date(pic_profile_date)

        set_player_pic_game(mRespPlayer.player_pic_game)
        set_player_pic_game_auth(mRespPlayer.player_pic_game_auth)

        var pic_game_date = moment(mRespPlayer.pic_game_date).format('YYYY-MM-DD HH:mm:ss')
        if (pic_game_date === "Invalid date")
          pic_game_date = ""
        set_player_pic_game_date(pic_game_date)

        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }


  function checkName(val) {
    setIsLoading(true)
    var mRespPlayer = new RespPlayer({
      player_name: val,
    })
    console.log(mRespPlayer)
    api_checkPlayerName({
      mRespPlayer,
      success: (jsonData) => {
        console.log(jsonData)
        setIsLoading(false)
        setCheckRepeat(true)
        if (jsonData.id === "") {
          setRepeat(false)
          setRepeatMessage("此球員名稱無重覆")
        } else {
          setRepeat(true)
          setRepeatMessage("與球員編號" + jsonData.id + "同名")
        }
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  function toEdit() {
    window.location.assign("/Player_Edit/" + id);
  }

  const onChange = (jsDate, dateString) => {
    //console.log(jsDate)
    //console.log(dateString)
    if (dateString === "Invalid date") {
      setBirthError(true)
    } else {
      setBirthError(false)
      set_player_DOB(dateString)
    }
  }


  function toCancel() {
    window.history.back();
  }


  function toAdd() {
    // console.log(player_type)
    var inputError = []
    if (player_name === "") {
      inputError.push("中文名字")
    }
    if(player_height === ""){
      inputError.push("身高")
    }
    if(player_weight === ""){
      inputError.push("體重")
    }

    if (inputError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: inputError.join(',') + ' 為必填',
      })
      return
    }

    setIsLoading(true)
    var mRespPlayer = new RespPlayer({
      player_id,
      player_name,
      player_name_eng,
      player_DOB,
      player_activation,
      player_last_change,
      player_position,
      player_throw_bat,
      player_height,
      player_weight,
      player_note,
      player_pic_profile,
      player_pic_profile_auth,
      player_pic_profile_date,
      player_pic_game,
      player_pic_game_auth,
      player_pic_game_date
    })

    console.log(mRespPlayer)
    api_addPlayer({
      isAdd,
      mRespPlayer,
      success: (jsonData) => {
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: isAdd ? '新增成功' : '修改成功',
        }).then(function () {
          toCancel()
        })
      },
      failure: (err) => {
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  var title = "球員" + (isAdd ? "新增" : isEdit ? "編輯" : "檢視")
  var content =
    <>
      <div className="row">
        <div className="col-sm-12">

          <div className="col-md-6">
            <UploadPhoto
              title={TITLE_player_pic_profile}
              Photo={player_pic_profile}
              PhotoAuth={player_pic_profile_auth}
              PhotoDate={player_pic_profile_date}
              setIsLoading={setIsLoading}
              set_Photo={set_player_pic_profile}
              set_PhotoAuth={set_player_pic_profile_auth}
              set_PhotoDate={set_player_pic_profile_date}
              isEdit={isEdit}
            />

          </div>

          <div className="col-md-6">
            <div className="row">
              {isEdit ?
                <SingleInput title={TITLE_player_name} val={player_name} action={set_player_name} action_blur={checkName} placeholder={""} size={8} />
                : <SingleText title={TITLE_player_name} val={player_name} size={8} />
              }
              {isEdit ?
                <div className="col-md-4">
                  <p>{TITLE_player_DOB}</p>
                  <DatePickerInput
                    displayFormat='YYYY/MM/DD'
                    returnFormat='YYYY-MM-DD'
                    onChange={onChange}
                    value={player_DOB}
                    className='my-react-component'
                    showOnInputClick={true}
                  />
                </div>
                : <SingleText title={TITLE_player_DOB} val={player_DOB} size={4} />
              }
            </div>
            {isCheckRepeat ?
              <div className="row">
                <div className="col-md-4">
                  <p className={isRepeat ? "text-danger" : "text-info"}>{repeatMessage}</p>
                </div>
              </div>
              : <></>}
            <Space />
            <Space />
            <Space />
            <div className="row">
              {isEdit ?
                <SingleInput title={TITLE_player_name_eng} val={player_name_eng} action={set_player_name_eng} placeholder={""} size={8} />
                : <SingleText title={TITLE_player_name_eng} val={player_name_eng} size={8} />
              }
              {isAdd ?
                <></>
                : <SingleText title={TITLE_player_id} val={_id} size={4} />
              }

            </div>
            <Space />
            <Space />
            <Space />
            <div className="row">
              {
                isEdit ?
                  <SingleRedio title={TITLE_player_activation}
                    arr={activation_Items}
                    val={player_activation ? 1 : 0}
                    action={set_player_activation}
                    size={4}
                  />
                  :
                  <SingleText title={TITLE_player_activation}
                    val={get_activation_string(player_activation)}
                    size={4} />
              }
              {isAdd ?
                <></>
                : <SingleText title={TITLE_player_last_change} val={player_last_change} size={4} />
              }

            </div>
            <Space />
            <Space />
            <Space />
            <div className="row">
              {isEdit ?
                <SingleSelect title={TITLE_player_position}
                  val={player_position}
                  attr={player_position_attr}
                  action={set_player_position}
                  hasBlank={true}
                  size={3}
                />
                : <SingleText title={TITLE_player_position} val={get_player_position_string(player_position)} size={3} />
              }

              {isEdit ?
                <SingleSelect title={TITLE_player_throw_bat}
                  val={player_throw_bat}
                  attr={player_throw_bat_attr}
                  action={set_player_throw_bat}
                  hasBlank={true}
                  size={3}
                />
                : <SingleText title={TITLE_player_throw_bat} val={get_player_throw_bat_string(player_throw_bat)} size={3} />
              }
              {isEdit ?
                <SingleInput title={TITLE_player_height} val={player_height} action={set_player_height} placeholder={""} size={3} />
                : <SingleText title={TITLE_player_height} val={player_height} size={3} />
              }
              {isEdit ?
                <SingleInput title={TITLE_player_weight} val={player_weight} action={set_player_weight} placeholder={""} size={3} />
                : <SingleText title={TITLE_player_weight} val={player_weight} size={3} />
              }
            </div>
            <Space />
            <Space />
            <Space />
            <div className="row">
              {isEdit ?
                <SingleInput title={TITLE_player_note} val={player_note} action={set_player_note} placeholder={"內部人員註記"} size={12} />
                : <SingleText title={TITLE_player_note} val={player_note} size={12} />
              }
            </div>
          </div>
        </div>

        <div className="col-sm-12">
          <div className="hr-line-dashed"></div>
        </div>

        <div className="col-sm-12">

          <div className="col-sm-6">
            <UploadPhoto
              title={"球員背景"}
              Photo={player_pic_game}
              PhotoAuth={player_pic_game_auth}
              PhotoDate={player_pic_game_date}
              setIsLoading={setIsLoading}
              set_Photo={set_player_pic_game}
              set_PhotoAuth={set_player_pic_game_auth}
              set_PhotoDate={set_player_pic_game_date}
              isEdit={isEdit}
            />
          </div>
        </div>
      </div>
    </>

  var footer =
      <div className="row">
      <div className="col-sm-12">
        {
          isAdd || isEdit ?
            <div className="col-sm-3 col-sm-offset-9">
              <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
            </div>
            :
            <EditButton action={toEdit} isRight={true} />
        }
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={false} />
      {isAdd||!isEdit?<></>:<PlayerHistoryList pId={player_id} setIsLoading={setIsLoading} />}
      <SystemPromptInput />
    </>
  )
}